/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box, FormControl, IInputProps, Input, WarningIcon } from 'native-base';

import { I18nReacher } from '@springbig/shared';

import { Caption, CaptionError } from './Typography';
import { ControllerRenderProps } from 'react-hook-form';

export interface InputFormProps extends IInputProps {
    type: any;
    label: I18nReacher;
    labelColor: string;
    placeholder?: string;
    onChange: (e: any) => void;
    errors?: string | null;
    required?: boolean;
    inputMode?: any;
    field?: ControllerRenderProps<any, any>;
}

const InputForm = ({
    fontSize = 14,
    w = '100%',
    h = 12,
    type,
    inputMode,
    onChange,
    label,
    errors,
    placeholder,
    required,
    defaultValue,
    labelColor = 'black',
    field,
    ...props
}: InputFormProps) => {

    return (
        <Box my={2} w={w}>
            <FormControl.Label>
                <Caption color={labelColor} text={label} fontSize={14} />
            </FormControl.Label>
            {type === 'date' ?
                <input
                    type={type}
                    defaultValue={defaultValue}
                    style={{
                        fontSize: fontSize as number,
                        backgroundColor: props.input_background,
                        borderColor: props.input_border,
                        color: props.input_text,
                        width: props.width as string
                    }}
                    placeholder={placeholder}
                    onChange={e => onChange(e.target.value)}
                    required={required}
                    disabled={props.isReadOnly}
                    max={new Date().toISOString().split('T')[0]}
                />
                :
                <Input
                    {...field}
                    {...props}
                    defaultValue={defaultValue}
                    testID={label.trim()}
                    type={type}
                    h={h}
                    fontSize={fontSize}
                    placeholder={placeholder}
                    onChangeText={onChange}
                    isRequired={required}
                    keyboardType={inputMode}
                />
            }
            {errors && (
                <FormControl.ErrorMessage mt={2}>
                    <Box flexDirection='row' alignItems='center'>
                        <WarningIcon
                            size="4"
                            mr="2"
                        />
                        <CaptionError>{errors}</CaptionError>
                    </Box>
                </FormControl.ErrorMessage>
            )}
        </Box>
    );
};

export default InputForm;
